import loadEssentials from './modules/Essentials.module';
const loadEssentialsModule = () => ({
    hasRouter: false,
    modules: [loadEssentials()],
});
export default loadEssentialsModule;
